import React from 'react';
import {Button, Col, Form, FormCheck, Modal, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircle} from "@fortawesome/free-solid-svg-icons";
import {toast} from "react-toastify";
import ApiService from "../api/ApiService";
import {useNavigate} from "react-router-dom";

const MigrationModal = ({visible, selectedBotList, spaceList, onClose}) => {

    const [isMobile, setIsMobile] = React.useState(false);
    const [targetSpaceId, setTargetSpaceId] = React.useState(0);
    const api = new ApiService();
    const navigate = useNavigate();

    React.useEffect(() => {
        const handleResize = () => {
            // 使用 setTimeout 实现简单的防抖
            const timer = setTimeout(() => {
                setIsMobile(window.innerWidth < 768);
            }, 100);

            return () => clearTimeout(timer);
        };
        handleResize(); // 初始化时调用
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); // 添加spaceList作为依赖项
    const submit = () => {
        if (targetSpaceId === 0) {
            toast.error('请选择目标空间');
            return;
        }
        const selectedBotListIds = [];
        selectedBotList.map((item) => {
            selectedBotListIds.push(item.id)
        })
        api.moveAgentList(selectedBotListIds, targetSpaceId).then(res => {
            if (res.code === 200) {
                navigate('/cozeList/CopyTaskList');
            }else {
                toast.error(res.msg);
            }
        });
    }

    return (
        <Modal show={visible} centered onHide={onClose}
               style={{'--bs-modal-margin': '2rem', '--bs-modal-width': '700px'}}>
            <Modal.Header closeButton style={{
                background: 'linear-gradient(90deg,#02C8E3 30%, #963BC8 120%)',
                borderBottomColor: 'transparent'
            }}>
                <div className={isMobile ? 'd-flex flex-column' : 'd-flex flex-row'}>
                    <span style={{color: '#060606', fontSize: '22px'}}>批量迁移智能体</span>
                    <span style={{
                        color: '#060606',
                        fontSize: isMobile ? '14px' : '18px',
                        alignSelf: 'end',
                        margin: isMobile ? '0' : '0 10px'
                    }}>
                    选择目标空间进行迁移
                    </span>
                </div>
            </Modal.Header>
            <Modal.Body style={{background: '#1E2129'}}>
                <p style={{color: '#B4BFC5'}}>已选择的智能体</p>
                <div style={{maxHeight: '200px', overflowY: 'auto', overflowX: 'hidden'}}>
                    {selectedBotList.map((item, index) => {
                        return (
                            <div key={index} style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: '10px',
                                background: '#42485A',
                                borderRadius: '8px',
                                padding: '4px 10px'
                            }}>
                                <img src={item.cover}
                                     style={{width: '40px', height: '40px', borderRadius: '4px', marginRight: '10px'}}
                                     alt={''}/>
                                <span style={{color: '#B4BFC5'}}>{item.title}</span>
                            </div>
                        )
                    })}
                </div>
                <p style={{color: '#B4BFC5'}}>选择目标空间</p>
                <div style={{maxHeight: '200px', overflowY: 'auto', overflowX: 'hidden'}}>
                    <Row>
                        {spaceList.map((item, index) => {
                            return (
                                <Col xs={12} lg={6} key={index}>
                                    <FormCheck
                                        key={index}
                                        type="radio"
                                        name="radio"
                                        id={item.id}
                                        checked={item.id === targetSpaceId}
                                        style={{
                                            background: '#141720',
                                            marginBottom: '10px',
                                            padding: '16px',
                                            borderRadius: '8px',
                                            display: 'flex',
                                            position: 'relative'
                                        }}
                                    >
                                        <FormCheck.Input
                                            style={{marginRight: '10px', marginLeft: '10px', alignSelf: 'center'}}
                                            type={'radio'}
                                            name={'radio'}
                                            onChange={() => {
                                                setTargetSpaceId(item.id);
                                            }}
                                        />
                                        <FormCheck.Label>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                position: 'relative',
                                                width: '100%',
                                                fontSize: '14px'
                                            }}>
                                                <div>
                                                    <p style={{color: '#B4BFC5'}}>{item.title ? item.title : '空间'}</p>
                                                    <div style={{color: '#B4BFC5'}}>ID：{item.id}</div>
                                                </div>
                                            </div>
                                        </FormCheck.Label>
                                        <span className={'badge rounded-pill'} style={{
                                            background: item.joinStatus === 1 ? 'rgba(4,215,243,0.3)' : 'rgba(242,99,99,0.3)',
                                            position: 'absolute',
                                            fontSize: '14px',
                                            color: item.joinStatus === 1 ? '#04D7F3' : '#F26363',
                                            top: '8px',
                                            right: '8px',
                                        }}><FontAwesomeIcon icon={faCircle}
                                                            width={'6px'}/> {item.joinStatus === 1 ? '官方已加入' : '等待加入'}</span>
                                    </FormCheck>
                                </Col>
                            )
                        })}
                    </Row>
                </div>
            </Modal.Body>
            <Modal.Footer style={{background: '#1E2129', borderTopColor: '#707070'}}>
                <Button variant="primary" onClick={() => {
                    submit()
                }} style={{
                    background: 'linear-gradient(90deg,#02C8E3,#963BC8)',
                    border: 'none',
                    padding: '12px 48px',
                    color: '#060606'
                }}>
                    确认迁移
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MigrationModal;